type ApiClientParams = {
  body?: Record<string, unknown>;
  method: string;
  token: string;
  updateStatusCallback?: (status?: number) => void;
  url: string;
};

export const authorizationHeader = (token: string) => ({
  Authorization: token,
});

export const apiClient = async ({ body, method, token, updateStatusCallback, url }: ApiClientParams) => {
  const response = await fetch(url, {
    body: body ? JSON.stringify(body) : undefined,
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
    method,
  });
  updateStatusCallback?.(response?.status);
  const data = await response.json();
  return data;
};
